import { gql } from "graphql-request";

const STRUCTURE_GROUP_FIELDS = `
  key
  title
  subtitle
  description
  path
  memberKind
  members {
    kind
    tag
    slug
    label
    badgeLabel
  }
`;

export const ADMIN_HANDBOOK_STRUCTURE = gql`
  query AdminHandbookStructure {
    adminHandbookStructure {
      groups {
        ${STRUCTURE_GROUP_FIELDS}
      }
    }
  }
`;

export const ADMIN_UPDATE_HANDBOOK_STRUCTURE = gql`
  mutation AdminUpdateHandbookStructure($input: AdminUpdateStructureInputDto!) {
    adminUpdateHandbookStructure(input: $input) {
      success
      message
      groups {
        ${STRUCTURE_GROUP_FIELDS}
      }
    }
  }
`;
